﻿/**
* DevExpress Analytics (core\elements\size.js)
* Version:  21.2.8
* Build date: Jun 7, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var _metadata_1 = require("../_metadata");
var Size = (function () {
    function Size(width, height) {
        this.isPropertyDisabled = function (name) { return void 0; };
        this.height = ko.observable(height).extend({ 'dxdnum': { min: 2 } });
        this.width = ko.observable(width).extend({ 'dxdnum': { min: 2 } });
    }
    Size.prototype.getInfo = function () {
        return _metadata_1.sizeFake;
    };
    Size.fromString = function (value) {
        if (value === void 0) { value = '0, 0'; }
        var components = value.split(',');
        return new Size(parseFloat(components[0]), parseFloat(components[1]));
    };
    Size.prototype.toString = function () {
        return this.width() + ', ' + this.height();
    };
    Size.unitProperties = ['width', 'height'];
    return Size;
}());
exports.Size = Size;
